module.exports = __webpack_public_path__ + "img/porto-5.94360b72.png";